import { render } from "./LanguageMenu.vue?vue&type=template&id=a05138be"
import script from "./LanguageMenu.vue?vue&type=script&lang=js"
export * from "./LanguageMenu.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__